import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { take, map } from 'rxjs/operators';

export class Countdown {
  private total: number = 0;
  private count: number = 0;
  public countDown: Observable<number>;
  private paused: boolean = false;

  constructor(
    public key: string
  ) { }

  start(count: number) {
    this.paused = false;
    this.count = count+1;
    this.total = count;
    this.countDown = timer(0,1000).pipe(take(this.count), map(x => {
      if (!this.paused) {
        this.count--;
      }
      return this.count;
    }));
  }

  pause() {
    this.paused = true;
  }
  resume() {
    this.paused = false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CountdownService {

  private countdowns: Countdown[] = [];

  constructor() { }

  public start(key: string, count: number): Observable<number> {
    const counter = this.getTimer(key);
    counter.start(count);
    return counter.countDown;
  }

  public stop(key: string): void {
    const counter = this.getTimer(key);
    const idx = this.countdowns.indexOf(counter);
    if (idx >= 0) {
      this.countdowns.splice(idx, 1);
    }
  }

  public pause(key: string): void {
    const counter = this.getTimer(key);
    counter.pause();
  }

  public resume(key: string): void {
    const counter = this.getTimer(key);
    counter.resume();
  }

  private getTimer(key: string) {
    return this.addCountdown(key);
  }

  private addCountdown(key: string): Countdown {
    let counter = this.countdowns.find(counter => counter.key === key);
    if (!counter) {
      counter = new Countdown(key);
      this.countdowns.push(counter);
    }
    return counter;
  }

}
